<script>
import { required, email, helpers } from "@vuelidate/validators";
import appConfig from "../../../app.config";
import { mymylogin } from "@/api/user";
// import axios from 'axios';

export default {
  page: {
    title: "Login",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  data() {
    return {
      username: "",
      password: "",
      passwordType: "password",
      submitted: false,
      authError: null,
      tryingToLogIn: false,
      isAuthError: false,
    };
  },
  validations: {
    username: {
      required: helpers.withMessage("Username is required", required),
    },
    password: {
      required: helpers.withMessage("Password is required", required),
    },
  },
  computed: {},
  methods: {
    async signinapi() {
      const fd = new FormData();
      fd.append("username", this.username);
      fd.append("password", this.password);

      mymylogin(fd)
        .then((res) => {
          var user_info = res[0];
          localStorage.setItem("token", user_info["access_token"]);
          localStorage.setItem("token_type", user_info["token_type"]);
          localStorage.setItem("backend_version", user_info["backend_version"]);
          localStorage.setItem("username", user_info["username"]);
          localStorage.setItem("menu_config", JSON.stringify(res[1]));

          this.$router.push("/");
        })
        .catch((error) => {
          console.log("login error: ", error);
          this.authError = "登录失败，请检查账号密码是否正确输入";
        });
    },
    showPassword() {
      this.passwordType = "text";
    },
    // Hide password when the mouse button is released or mouse leaves
    hidePassword() {
      this.passwordType = "password";
    },
  },
};
</script>

<template>
  <div class="auth-page-wrapper pt-5">
    <!-- auth page bg -->
    <div class="auth-one-bg-position auth-one-bg" id="auth-particles">
      <div class="bg-overlay"></div>

      <div class="shape">
        <svg xmlns="http://www.w3.org/2000/svg" version="1.1" xmlns:xlink="http://www.w3.org/1999/xlink"
          viewBox="0 0 1440 120">
          <path d="M 0,36 C 144,53.6 432,123.2 720,124 C 1008,124.8 1296,56.8
            1440,40L1440 140L0 140z"></path>
        </svg>
      </div>
    </div>

    <!-- auth page content -->
    <div class="auth-page-content">
      <div class="container">
        <div class="row">
          <div class="col-lg-12">
            <div class="text-center mt-sm-5 mb-4 text-white-50">
              <div>
                <router-link to="/" class="d-inline-block auth-logo">
                  <!-- <img src="@/assets/images/logo-light.png" alt="" height="20" /> -->
                </router-link>
              </div>
              <!-- <p class="mt-3 fs-15 fw-medium">
                Premium Admin & Dashboard Template
              </p> -->
            </div>
          </div>
        </div>
        <!-- end row -->

        <div class="row justify-content-center">
          <div class="col-md-8 col-lg-6 col-xl-5">
            <div class="card mt-4">
              <div class="card-body p-4">
                <div class="text-center mt-2">
                  <img src="@/assets/images/logo-dark.png" alt="" height="42" />
                </div>
                <div class="p-2 mt-4">
                  <b-alert
                    v-model="authError"
                    variant="danger"
                    class="mt-3"
                    dismissible
                    >{{ authError }}</b-alert
                  >

                  <form @submit.prevent="tryToLogIn">
                    <div class="mb-3">
                      <label for="username" class="form-label">用户名</label>
                      <input
                        type="text"
                        class="form-control"
                        id="username"
                        placeholder="输入用户名"
                        v-model="username"
                      />
                      <div class="invalid-feedback">
                        <span></span>
                      </div>
                    </div>

                    <div class="mb-3">
                      <label class="form-label" for="password-input"
                        >密码</label
                      >
                      <div class="position-relative auth-pass-inputgroup mb-3">
                        <input
                          :type="passwordType"
                          v-model="password"
                          class="form-control pe-5"
                          placeholder="输入密码"
                          id="password-input"
                        />
                        <button
                          class="btn position-absolute end-0 top-0 text-decoration-none text-muted"
                          style="box-shadow: none"
                          type="button"
                          id="password-addon"
                          @mousedown="showPassword"
                          @mouseup="hidePassword"
                          @mouseleave="hidePassword"
                        >
                          <i class="ri-eye-fill align-middle"></i>
                        </button>
                        <div class="invalid-feedback">
                          <span></span>
                        </div>
                      </div>
                    </div>

                    <div class="form-check">
                      <input
                        class="form-check-input"
                        type="checkbox"
                        value=""
                        id="auth-remember-check"
                      />
                      <label class="form-check-label" for="auth-remember-check"
                        >记住我</label
                      >
                    </div>

                    <div class="mt-4">
                      <button
                        class="btn btn-success w-100"
                        type="submit"
                        @click="signinapi"
                      >
                        登录
                      </button>
                    </div>
                  </form>
                </div>
              </div>
              <!-- end card body -->
            </div>
            <!-- end card -->
          </div>
        </div>
        <!-- end row -->
      </div>
      <!-- end container -->
    </div>
    <!-- end auth page content -->
  </div>
  <!-- end auth-page-wrapper -->
</template>
